import { useTripsActivatedWillCallCountRetrieveQuery } from '@bambi/api-client/trips';
import { DateTime } from 'luxon';

import { useFeature } from 'src/app/FeatureToggle';
import { useAppSelector } from 'src/app/store/hooks';
import { useUserRoles } from 'src/features/auth/useUserRoles';
import { makeDispatchTimeRange } from 'src/features/dispatch/common/makeDispatchTimeRange';

export function useUnassignedWillCallTripBadge() {
  const POOLING_INTERVAL = 3 * 60 * 1000; // 3 minutes

  const isAddATripFormOpen = useAppSelector((state) => state.addATrip.isOpen);

  const { isRideOrderingPortalUser } = useUserRoles();
  const { isEnabled: isActivatedWillCallCountEnabled } = useFeature(
    'activated will call count'
  );
  const today = DateTime.now().toISODate();
  const range = makeDispatchTimeRange(today);

  const { data: unassignedWillCallTrips } =
    useTripsActivatedWillCallCountRetrieveQuery(
      {
        rangeEnd: range.end,
        rangeStart: range.start,
      },
      {
        pollingInterval: POOLING_INTERVAL,
        skip:
          !isActivatedWillCallCountEnabled ||
          isRideOrderingPortalUser ||
          isAddATripFormOpen,
      }
    );

  return {
    unassignedWillCallTrips,
  };
}
